import { Fragment } from "react";
import { firstLetterCapital } from "_utils";
import {
  NoRecordFoundTable,
  TransactionStatus,
  OfferInfoInTable,
  GetTrackingLinkButton,
} from "_components";
import { UserAppliedOfferStatus } from "_constants";

const columns = [
  { label: "Advertiser", class: "min-w-250px" },
  { label: "Category", class: "min-w-250px" },
  { label: "Commission", class: "min-w-100px" },
  { label: "Country", class: "min-w-200px" },
  { label: "Status", class: "min-w-100px" },
];

export const ListingTable = ({ data, status }) => {
  if (!columns.some((col) => col.label === "Action")) {
    columns.push({ label: "Action", class: "text-center min-w-200px" });
  }
  return (
    <Fragment>
      <table className="table align-middle table-nowrap mb-0">
        <thead className="table-light">
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody className="list form-check-all">
          {data &&
            data.map((offer) => (
              <tr key={offer._id}>
                <td>
                  <OfferInfoInTable offer={offer} />
                </td>
                <td>{offer.category?.categoryName}</td>
                <td>
                  <span>
                    <span className="badge bg-light text-body fs-12 fw-medium">
                      <i className="mdi mdi-star text-warning me-1"></i>
                      {offer.commission}%
                    </span>
                  </span>
                </td>
                <td>{firstLetterCapital(offer.country)}</td>
                <td>
                  <TransactionStatus status={status} />
                </td>
                {status === UserAppliedOfferStatus.APPROVED && (
                  <td className="text-center">
                    <GetTrackingLinkButton offer={offer} />
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </table>
      {data && data.length === 0 && <NoRecordFoundTable />}
    </Fragment>
  );
};
